import { useState, useEffect } from 'react'
import { Link } from 'react-router-dom'
import BriefCard from '../components/BriefCard'
import { API_BASE } from '../config'

export default function Dashboard() {
    const [stats, setStats] = useState(null)
    const [cases, setCases] = useState([])
    const [loading, setLoading] = useState(true)
    const [error, setError] = useState('')

    useEffect(() => {
        loadData()
    }, [])

    async function loadData() {
        try {
            setLoading(true)
            const [statsRes, casesRes] = await Promise.all([
                fetch(`${API_BASE}/cases/stats`),
                fetch(`${API_BASE}/cases/`),
            ])
            if (!statsRes.ok || !casesRes.ok) throw new Error('API error')
            const statsData = await statsRes.json()
            const casesData = await casesRes.json()
            setStats(statsData)
            setCases(casesData.cases || [])
        } catch (err) {
            setError(err.message)
        } finally {
            setLoading(false)
        }
    }

    if (loading) {
        return (
            <div className="loading">
                <div className="spinner"></div>
                <p>Loading dashboard...</p>
            </div>
        )
    }

    if (error) {
        return (
            <div className="card">
                <p style={{ color: 'var(--error)' }}>Error: {error}</p>
                <button className="btn btn-primary mt-2" onClick={loadData}>
                    Retry
                </button>
            </div>
        )
    }

    return (
        <div>
            <div className="flex-between mb-3">
                <h2>Dashboard</h2>
                <Link to="/cases/new" className="btn btn-primary">
                    + New Case
                </Link>
            </div>

            {/* Stats */}
            <div className="stats-grid">
                <div className="stat-card">
                    <div className="stat-value">{stats?.total_cases || 0}</div>
                    <div className="stat-label">Total Cases</div>
                </div>
                <div className="stat-card">
                    <div className="stat-value">{stats?.active_research || 0}</div>
                    <div className="stat-label">Active Research</div>
                </div>
                <div className="stat-card">
                    <div className="stat-value">{stats?.completed || 0}</div>
                    <div className="stat-label">Completed</div>
                </div>
                <div className="stat-card">
                    <div className="stat-value">{stats?.vendors_found || 0}</div>
                    <div className="stat-label">Vendors Found</div>
                </div>
            </div>

            {/* Recent Cases */}
            <div className="card">
                <h2>Recent Cases</h2>
                {cases.length === 0 ? (
                    <p className="text-muted">No cases yet. Create your first research case!</p>
                ) : (
                    <div className="cases-list">
                        {cases.map((c) => (
                            <Link to={`/cases/${c.id}`} key={c.id} className="case-item" style={{ textDecoration: 'none' }}>
                                <div className="case-info">
                                    <h3>{c.case_number} — {c.client_name}</h3>
                                    <p>{c.problem_description?.substring(0, 120)}...</p>
                                </div>
                                <Badge status={c.status} />
                            </Link>
                        ))}
                    </div>
                )}
            </div>
        </div>
    )
}

function Badge({ status }) {
    const config = {
        researching: { label: 'Researching', cls: 'badge-researching' },
        completed: { label: 'Completed', cls: 'badge-completed' },
    }
    const { label, cls } = config[status] || { label: status, cls: 'badge-default' }
    return <span className={`badge ${cls}`}>{label}</span>
}